/**
 * @generated SignedSource<<4a171dc3f24fa33365671bc293ee926d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SpaceStarWriteStarredSpacesFragment$data = {
  readonly nodes: ReadonlyArray<{
    readonly alias: string | null | undefined;
    readonly icon: {
      readonly path: string;
    } | null | undefined;
    readonly id: string | null | undefined;
    readonly key: string | null | undefined;
    readonly name: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "SpaceStarWriteStarredSpacesFragment";
};
export type SpaceStarWriteStarredSpacesFragment$key = {
  readonly " $data"?: SpaceStarWriteStarredSpacesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SpaceStarWriteStarredSpacesFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "SpaceStarWriteStarredSpacesFragment",
  "selections": [
    {
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "alias"
        },
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "concreteType": "Icon",
          "kind": "LinkedField",
          "name": "icon",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "path"
            }
          ]
        }
      ]
    }
  ],
  "type": "PaginatedSpaceList"
};

(node as any).hash = "72f0ab1980fee3d3ebcdbd9647ddc161";

export default node;
